import { createI18n } from 'vue-i18n';

// Supported locales
const supported = ['en', 'tr'];

function detectLocale() {
	// 1) query param `lang`
	try {
		const url = new URL(window.location.href);
		const q = (url.searchParams.get('lang') || '').toLowerCase();
		if (q && supported.includes(q)) return q;
	} catch (e) { /* ignore */ void e; }

	// 2) localStorage
	const ls = (typeof localStorage !== 'undefined') ? (localStorage.getItem('lang') || '').toLowerCase() : '';
	if (ls && supported.includes(ls)) return ls;

	// 3) navigator.language
	const nav = (typeof navigator !== 'undefined' && navigator.language) ? navigator.language.toLowerCase() : 'en';
	const base = nav.split('-')[0];
	if (supported.includes(base)) return base;

	// 4) default
	return 'en';
}

async function loadLocaleMessages(locale) {
	switch (locale) {
		case 'tr':
			return (await import(/* webpackChunkName: "locale-tr" */'@/locales/tr.json')).default;
		case 'en':
		default:
			return (await import(/* webpackChunkName: "locale-en" */'@/locales/en.json')).default;
	}
}

export async function setupI18n() {
	const locale = detectLocale();
	const messages = { [locale]: await loadLocaleMessages(locale) };

	const i18n = createI18n({
		legacy: false,
		locale,
		fallbackLocale: 'en',
		messages
	});

	// expose a method to change locale dynamically with lazy-load
	i18n.setLocale = async (next) => {
		if (!supported.includes(next)) next = 'en';
		if (!i18n.global.availableLocales.includes(next)) {
			const msgs = await loadLocaleMessages(next);
			i18n.global.setLocaleMessage(next, msgs);
		}
		i18n.global.locale.value = next;
		try { localStorage.setItem('lang', next); } catch (e) { /* ignore */ void e; }
		if (typeof document !== 'undefined') {
			document.documentElement.setAttribute('lang', next);
		}
	};

	// set <html lang>
	if (typeof document !== 'undefined') {
		document.documentElement.setAttribute('lang', locale);
	}

	return i18n;
}
